// Função de validação do CNPJ (exemplo básico)
export const validarCNPJ = (cnpj: string) => {
    // Remover caracteres não numéricos
    const cleaned = cnpj.replace(/\D/g, '');
    return cleaned.length === 14; // Verificação simples, ajuste para validar melhor se necessário
};

// Função de validação de e-mail
export const validarEmail = (email: string) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
};

// Função de validação de telefone
export const validarTelefone = (telefone: string) => {
    const regex = /^\(?\d{2}\)?[\s-]?\d{4,5}[\s-]?\d{4}$/;
    return regex.test(telefone);
};
